import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-semibold text-xl" }
const _hoisted_2 = {
  style: {"width":"45rem"},
  class: "relative overflow-y-auto"
}
const _hoisted_3 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return _withDirectives((_openBlock(), _createBlock(_component_Dialog, {
    "model-value": _ctx.modelValue,
    persistent: true,
    header: false
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("courierManagement.riwayatPermintaanKurir")), 1),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_TableV2, {
          loading: _ctx.dataHistory?.loading,
          borderTop: false,
          borderBottom: false,
          columns: _ctx.columns,
          data: _ctx.dataHistory?.data,
          isEmpty: _ctx.isEmptyList,
          emptyHeaderMessage: _ctx.$t('courierManagement.riwayatPermintaanKurir'),
          class: "my-2",
          pagination: _ctx.dataHistory.pagination,
          "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataHistory.pagination = $event)),
          paginationStyle: "v1"
        }, null, 8, ["loading", "columns", "data", "isEmpty", "emptyHeaderMessage", "pagination"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_lp_button, {
          outline: "",
          "text-color": "red-lp-100",
          "custom-class": "px-10",
          title: _ctx.$t('courierManagement.back'),
          onClick: _ctx.handleCloseModal
        }, null, 8, ["title", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"])), [
    [_vShow, _ctx.showingDialog]
  ])
}